import React, { useState } from 'react'
import { useSelector, shallowEqual, useDispatch } from 'dva'
import { useHistory } from 'react-router-dom'
import styles from './index.module.less'
import Form from 'rc-field-form'
import { Input, PhoneInput, CodeInput } from 'app/mobile/components'
import { FormItem, Button } from 'components'
import { phoneValidator, checkPassWord } from 'utils'
import { isMobileBrowser } from 'utils/tools'

const selector = ({ loading }) => ({
  loading: loading.effects['login/resetPassword'],
})
export default function Index() {
  const dispatch = useDispatch()
  const { loading } = useSelector(selector, shallowEqual)
  const history = useHistory()
  const [mobile, setMobile] = useState({})
  const [form] = Form.useForm()

  // 输入时触发
  const valuesChange = () => {
    const values = form.getFieldsValue()
    setMobile(values?.mobile)
    if (!values.password && values.password !== 0) return
  }

  // 提交
  const onFinish = async values => {
    await dispatch({
      type: 'login/resetPassword',
      payload: {
        ...values,
        areaCode: values.mobile.areaCode,
        mobile: values.mobile.mobile,
      },
    })
    let path = `${isMobileBrowser() ? '/mobile' : ''}/id`
    history.push(path)
  }

  // 校验密码
  const passWord = (rule, value, callback) => {
    let grade = checkPassWord(value)
    if (!value || value === undefined) return Promise.reject('请输入新密码')
    if (value.length < 8 || value.length > 20) {
      return Promise.reject('密码长度为8-20位的数字/字母/符号')
    }
    if (!grade) {
      return Promise.reject(
        '密码安全性过低，至少包含数字/大写字母/小写字母/符号中的三项'
      )
    }
    Promise.resolve()
    callback()
  }

  // 确认密码
  const confirmPass = (rule, value, callback) => {
    let formvalue = form.getFieldsValue()
    if (!value || value === undefined) return Promise.reject('请确认新密码')
    if (formvalue.password !== value) {
      return Promise.reject('两次密码输入不一致')
    }
    Promise.resolve()
    callback()
  }
  return (
    <div>
      <div className={styles.header}>重置密码</div>
      <div className={styles.cont}>
        <Form form={form} onFinish={onFinish} onValuesChange={valuesChange}>
          <FormItem
            name="workId"
            rules={[{ required: true, message: '请输入工号' }]}>
            <Input placeholder="请输入工号" trim={true} />
          </FormItem>
          <FormItem
            name="mobile"
            rules={[
              { required: true, message: '请输入手机号码' },
              { validator: phoneValidator },
            ]}>
            <PhoneInput />
          </FormItem>
          <FormItem
            name="validCode"
            rules={[
              { required: true, message: '请输入验证码' },
              { pattern: /^\d{6}$/, message: '请输入正确的验证码' },
            ]}>
            <CodeInput mobile={{ ...mobile, smsType: 'RESET_PASSWORD' }} />
          </FormItem>
          <FormItem
            name="password"
            rules={[
              {
                required: true,
                validator: (rule, value, callback) =>
                  passWord(rule, value, callback),
              },
            ]}>
            <Input type="passWord" placeholder="请输入新密码" />
          </FormItem>
          <FormItem
            name="newPassword"
            rules={[
              {
                required: true,
                validator: (rule, value, callback) =>
                  confirmPass(rule, value, callback),
              },
            ]}>
            <Input type="passWord" placeholder="请确认新密码" />
          </FormItem>
          <Button
            htmlType="submit"
            className={styles.but}
            type="primary"
            shape="round"
            loading={loading}>
            提交
          </Button>
        </Form>
      </div>
    </div>
  )
}
